import {context} from 'vue3-starter/src/typescript/app-context/AppContext';
import {useCookies} from '@malt/vue3-use';
import {HttpServiceResponse} from 'vue3-starter/src/typescript/http/http';
import {userResourceBuilder} from '@/brief-hub/user/UserResourceBuilder';
import UserResource from '@/brief-hub/user/UserResource';
import * as RawModel from '@/common/api/api-raw-types';

export class UserService {
    async get(): Promise<HttpServiceResponse<UserResource>> {
        const [result, err] = await context.httpService.get<RawModel.BriefUserResource>(context.registry.entries.getUserInfo());

        return result ? [this.resourceBuilder(result), null] : [null, err];
    }

    async fetchBriefClient(url: string, identityId: string): Promise<HttpServiceResponse<UserResource>> {
        const [result, err] = await context.httpService.get<RawModel.BriefUserResource>(url + `?identityId=${identityId}`);
        return result ? [this.resourceBuilder(result), null] : [null, err];
    }

    redirectToIdentity(identityId: string, redirectionUrl: string): void {
        const {XSRFTOKEN} = useCookies(['XSRF-TOKEN']);
        const form = document.createElement('form');
        form.setAttribute('method', 'post');
        form.setAttribute('action', context.registry.entries.identity());

        const params = {
            identityId,
            redirectionUrl,
            _csrf: XSRFTOKEN,
        };

        for (const [key, value] of Object.entries(params)) {
            const hiddenField = document.createElement('input');
            hiddenField.setAttribute('type', 'hidden');
            hiddenField.setAttribute('name', key);
            hiddenField.setAttribute('value', value);

            form.appendChild(hiddenField);
        }

        document.body.appendChild(form);
        form.submit();
    }

    protected resourceBuilder(data: RawModel.BriefUserResource): UserResource {
        return userResourceBuilder.build(data);
    }
}

export default new UserService();
